export const UPDATE_SEARCH_DATE = '@report/update-search-date';

export function updateSearchDate(search_start_date, search_end_date) {
  return (dispatch) => dispatch({
    type: UPDATE_SEARCH_DATE,
    payload: {
      search_start_date,
      search_end_date
    }
  });
}
